import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { initialsOf } from '../lib/format';
import { BRAND_LOGO_ALT, BRAND_LOGO_SRC } from '../config/brand';

const NAV = [
  { to: '/', label: 'Home', end: true },
  { to: '/clients', label: 'Clients', end: false },
  { to: '/reps', label: 'Reps', end: false },
  { to: '/features', label: 'Features', end: false },
  { to: '/support', label: 'Support', end: false }
];

export default function Topbar() {
  const { user, logout } = useAuth();
  const name = user?.displayName || user?.email || 'Admin';

  return (
    <div className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {/* The lockup already carries the wordmark, so no text label beside it. */}
        <NavLink to="/" className="brand" aria-label="Lushin admin home">
          <img className="brand-logo" src={BRAND_LOGO_SRC} alt={BRAND_LOGO_ALT} />
        </NavLink>
        <nav className="nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="top-right">
        <button className="btn" onClick={() => logout()}>
          Sign out
        </button>
        <span className="avatar" title={name}>
          {initialsOf(name)}
        </span>
      </div>
    </div>
  );
}
